export enum MathEssentialsAnalyticsEvents {
  CHECK_ANSWER = 'check_answer',
  NEXT_QUESTION_NAVIGATION = 'math_essentials_quiz:next_question',
  QUIZ_COMPLETED = 'quiz_completed',
}
